import { Label, Spinner } from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import faceTip from '../../assets/lottie/faceTip.json';
import voiceTipDesktop from '../../assets/lottie/voiceTipDesktop.json';
import voiceTipMobile from '../../assets/lottie/voiceTipMobile.json';
import { useDeviceSize } from '../../hooks';
import { widgetTypeState, widgetTypes } from '../../states';
import { LottieAnimation } from '../lottieAnimation';
import { ContainerHelp, ContainerHelpButton } from './Styles';

type IProps = {
  onClick(): void;
  loading: boolean;
};

export const HelpWidget = ({ onClick, loading }: IProps) => {
  const { t } = useTranslation();
  const { isDesktop } = useDeviceSize();
  const widgetType = useRecoilValue(widgetTypeState);
  const isFacial = widgetType === widgetTypes.facial;
  const DESKTOP_SIZE = '32rem';
  const MOBILE_SIZE = '24rem';
  const lottieStyles = isDesktop
    ? { height: DESKTOP_SIZE, width: DESKTOP_SIZE }
    : { height: MOBILE_SIZE, width: MOBILE_SIZE };
  const voiceTip = isDesktop ? voiceTipDesktop : voiceTipMobile;

  return (
    <ContainerHelp
      flexDirection="column"
      flex="1"
      alignItems="center"
      rowGap={isDesktop ? '3.2' : '2.4'}
    >
      <Label
        fontSize={isDesktop ? '32' : '24'}
        textAlign="center"
        semibold
        noWrap
        testId="previous_tip_title"
      >
        {t(isFacial ? 'Facial recognition' : 'Voice recognition')}
      </Label>
      <LottieAnimation
        animation={isFacial ? faceTip : voiceTip}
        style={{ padding: '2rem', ...lottieStyles }}
        idTest="previous_tip_animation"
      />

      <Label
        fontSize="18"
        textAlign="center"
        testId="previous_tip_description_text"
      >
        {t(
          isFacial
            ? 'Place your face inside the circle'
            : 'Speak clearly and loudly. Make sure you are in a quiet environment.'
        )}
      </Label>

      <ContainerHelpButton
        color="secondary"
        onClick={onClick}
        size="L"
        testId="previous_tip_start_button"
        disabled={loading}
      >
        {loading ? (
          <Spinner insideComponent size="S" />
        ) : (
          t('Start').toUpperCase()
        )}
      </ContainerHelpButton>
    </ContainerHelp>
  );
};
